// extracted by mini-css-extract-plugin
export var aircallIframe = "_el-3";
export var fabContainer = "_el-5";
export var fabRinging = "_el-6";
export var loadingOverlay = "_el-4";
export var pulse = "_el-7";
export var widgetContent = "_el-2";
export var widgetPanel = "_el-0";
export var widgetPanelExpanded = "_el-1";